<template>
  <div class="user-info-box-content">
    <div class="info as-flex flex-vertical main-start cross-start">
      <div class="company f-3">{{userInfo&&userInfo.name?userInfo.name:'--'}}</div>
      <div class="mobile-password as-flex main-start cross-center f-2">
        <div class="mobile">
          {{userInfo&&userInfo.mobile?userInfo.mobile : '未绑定手机'}}
          (
          <span
            class="operation"
            @click="bindOrubindMobile(userInfo&&userInfo.mobile?'unbind':'bind')"
          >{{userInfo&&userInfo.mobile?'解绑':'绑定' }}</span>
          )
        </div>
        <div @click="changePassword('change')" class="password operation">修改密码</div>
      </div>
      <div class="account-grant as-flex flex-vertical main-between cross-start f-2">
        <span>账号权限：{{userInfo&&userInfo.expire_time?userInfo.expire_time : '长期有效'}}</span>
        <span>账号类型：{{userInfo&&userInfo.category?userInfo.category : '--'}}</span>
      </div>
    </div>
    <div class="introduce as-flex main-around cross-center f-2">
      <div
        @click="commitRequirement"
        class="introduce-func as-flex flex-vertical main-center cross-center"
      >
        <img class="userinfo-img" src="../../assets/images/userinfo-requirement.png" alt />
        <span>发起需求</span>
      </div>
      <div
        class="introduce-func as-flex flex-vertical main-center cross-center"
        @click="introduction"
      >
        <img class="userinfo-img" src="../../assets/images/userinfo-guide.png" alt />
        <span>使用教程</span>
      </div>
      <div class="introduce-func as-flex flex-vertical main-center cross-center" @click="aboutus">
        <img class="userinfo-img" src="../../assets/images/userinfo-aboutus.png" alt />
        <span>关于我们</span>
      </div>
    </div>
    <div class="logout as-flex main-center cross-center">
      <div @click="logout" class="louout-btn as-flex main-center cross-center">退出</div>
    </div>
    <template v-if="modal.visibility">
      <component
        v-bind:is="modalsMapping[modal.type]"
        :defaultConfig="modal.defaultConfig"
        @closeModal="closeModal"
      ></component>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import mobileModal from "../modals/mobile";
import passwordModal from "../modals/password";
import requirementModal from "../modals/requirement";
import guideModal from "../modals/guide";
import aboutusModal from "../modals/aboutus";

const modalsMapping = {
  mobile: "mobileModal",
  password: "passwordModal",
  requirement: "requirementModal",
  guide: "guideModal",
  aboutus: "aboutusModal"
};
export default {
  name: "userInfoBox",
  props: {
    userInfo: {}
  },
  components: {
    mobileModal: mobileModal,
    passwordModal: passwordModal,
    requirementModal: requirementModal,
    guideModal: guideModal,
    aboutusModal: aboutusModal
  },
  data() {
    return {
      modalsMapping: modalsMapping,
      modal: {
        visibility: false,
        type: undefined,
        defaultConfig: {}
      }
    };
  },
  computed: {
    ...mapGetters({
      tabs: "tabpage/getTabPages"
    })
  },
  methods: {
    logout() {
      this.$store.dispatch("user/logout");
    },
    closeModal() {
      this.modal.visibility = false;
      this.modal.type = undefined;
      this.modal.defaultConfig = {};
    },
    //show modal with certain type
    showModal(type) {
      this.modal.visibility = true;
      this.modal.type = type;
      this.modal.defaultConfig = Object.assign(this.modal.defaultConfig, {
        mobile: this.userInfo.mobile,
        company: this.userInfo.company
      });
    },
    //bind or unbind mobile
    bindOrubindMobile(type) {
      this.modal.defaultConfig.type = type;
      this.showModal("mobile");
    },
    //change password
    changePassword(type) {
      this.modal.defaultConfig.type = type;
      this.showModal("password");
    },
    //commit requirement
    commitRequirement() {
      let mobile = this.$store.getters["user/getUserInfo"].mobile;
      let company = this.$store.getters["user/getUserInfo"].company;
      this.$requireModal({ mobile, company });
    },
    introduction() {
      // this.$message("敬请期待");
      window.open("https://tracking.fanink.cn/guide/index.html", "_blank");
    },
    aboutus() {
      // this.$message("敬请期待");
      this.showModal("aboutus");
    }
  },
  watch: {}
};
</script>

<style lang="scss" scoped>
.user-info-box-content {
  width: 100%;
  height: 100%;
  box-shadow: 0 0 4px 2px #efefef;
}
.info {
  width: 100%;
  height: 35%;
  padding: 5px 20px;
  //背景渐变
  background: -webkit-linear-gradient(
    90deg,
    #4ab7fd,
    #81ccfc
  ); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(
    90deg,
    #4ab7fd,
    #81ccfc
  ); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(
    90deg,
    #4ab7fd,
    #81ccfc
  ); /* Firefox 3.6 - 15 */
  background: linear-gradient(
    90deg,
    #4ab7fd,
    #81ccfc
  ); /* 标准的语法（必须放在最后） */
  .company {
    margin: 5px 0;
    color: #fff;
  }
  .mobile-password {
    margin: 6px 0 10px 0;
    color: #fff;
    .operation {
      &:hover {
        cursor: pointer;
        color: #1da5fa;
      }
    }
    .mobile {
      margin-right: 15px;
    }
  }
  .account-grant {
    color: #fff;
    font-weight: 300;
  }
}
.introduce {
  width: 100%;
  height: 35%;
  font-weight: 300;
  color: #666666;
  .introduce-func {
    cursor: pointer;
    &:hover {
      animation: myBounce 0.5s;
    }
  }
  .userinfo-img {
    width: 50px;
    margin-bottom: 10px;
  }
}
.logout {
  width: 100%;
  height: 30%;
  .louout-btn {
    cursor: pointer;
    width: 50%;
    height: 2.5em;
    color: #fff;
    border-radius: 1.25em;
    background: -webkit-linear-gradient(
      90deg,
      #4ab7fd,
      #81ccfc
    ); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(
      90deg,
      #4ab7fd,
      #81ccfc
    ); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(
      90deg,
      #4ab7fd,
      #81ccfc
    ); /* Firefox 3.6 - 15 */
    background: linear-gradient(
      90deg,
      #4ab7fd,
      #81ccfc
    ); /* 标准的语法（必须放在最后） */
  }

  /*animations*/
  @keyframes myBounce {
    0% {
      transform: scale(1.1);
    }
    50% {
      transform: scale(0.9);
    }
    100% {
      transform: scale(1);
    }
  }
}
</style>
